import package_json from "../../package.json";

const APP_VERSION     = 'v' + package_json.version;
const APP_NAME        = 'Sistema Gerencial';
const APP_PREFIX      = 'gerencial_';
const APP_DESCRIPTION = 'Programa Gerencial de Empresas';

const IS_PRODUCTION   = process.env.NODE_ENV === 'production';

const BASE_URL_DEVELOPMENT = 'http://localhost:8080';
// const BASE_URL_PRODUCTION  = 'http://186.235.184.214/gerencial';
const BASE_URL_PRODUCTION  = window.location.origin;
const BASE_URL_PRINT_DEV   = 'http://etcrm.test';

const BASE_URL       = IS_PRODUCTION ? BASE_URL_PRODUCTION: BASE_URL_DEVELOPMENT;
const BASE_URL_PRINT = IS_PRODUCTION ? BASE_URL_PRODUCTION: BASE_URL_PRINT_DEV;
const API_URL        = BASE_URL + '/api/v1';

// const COOKIE_EXPIRATION_TIME = 24 * 60;
const COOKIE_EXPIRATION_TIME = 0;

const STORAGE_USER  = APP_PREFIX + 'user';
const STORAGE_TOKEN = APP_PREFIX + 'token';
const STORAGE_ENCRYPT = true;

export default {
  APP_VERSION,
  APP_NAME,
  APP_DESCRIPTION,
  BASE_URL_PRODUCTION,
  BASE_URL,
  API_URL,
  BASE_URL_PRINT,
  IS_PRODUCTION,
  COOKIE_EXPIRATION_TIME,
  STORAGE_USER,
  STORAGE_TOKEN,
  STORAGE_ENCRYPT,
  APP_PREFIX
}
